import {
    Directive,
    ElementRef,
    InputSignal,
    SecurityContext,
    effect,
    inject,
    input, OnInit,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { marked } from 'marked';

@Directive({
    selector: '[cargoMd]',
    standalone: true,
})
export class CargoMdDirective implements OnInit {
    cargoMd: InputSignal<string> = input('');

    private _sanitize: DomSanitizer = inject(DomSanitizer);
    private _el: ElementRef = inject(ElementRef);

    constructor() {
        effect(() => {
            this._el.nativeElement.innerHTML = this.append();
        });
    }

    ngOnInit(): void {
        this._el.nativeElement.innerHTML = this.append();
    }

    private append(): any {
        return !!this.cargoMd()?.length ? this.render(this.cargoMd()) : '';
    }

    render(md: string): string {
        return this._sanitize.sanitize(SecurityContext.HTML, marked(md));
    }
}
